import { SET_COACHMARKS, COACHMARKS_API_REQUEST, COACHMARKS_API_SUCCESS, COACHMARKS_API_FAILURE } from './actionTypes';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';

const coachmarksApiRequest = () => ({
  type: COACHMARKS_API_REQUEST,
});

const coachmarksApiSuccess = () => ({
  type: COACHMARKS_API_SUCCESS,
});

const coachmarksApiFailure = error => ({
  type: COACHMARKS_API_FAILURE,
  error,
});

const setCoachmarks = ({ data }) => ({
  type: SET_COACHMARKS,
  payload: {
    data,
  },
});

export const resetCoachmarks = () => async (dispatch, getState, { fetch }) => {
  const { applicationId } = getState().user;
  const { apiVersion } = getState().runtime;
  const { locale } = getState().intl;

  dispatch(coachmarksApiRequest());

  const coachmarkData = {
    apply_coachmarks_complete: false,
    search_coachmarks_complete: false,
    saved_coachmarks_complete: false,
    scheduled_coachmarks_complete: false,
  };

  const serverData = {
    student_application_id: applicationId,
    ...coachmarkData,
  };

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/settings/update-coachmarks/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/json; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'PUT',
    body: JSON.stringify(serverData),
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(() => {
      dispatch(
        setCoachmarks({
          data: coachmarkData,
        }),
      );
      dispatch(coachmarksApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(coachmarksApiFailure({ error }));
    });
};

export const dismissCoachmark = ({ context }) => async (dispatch, getState, { fetch }) => {
  const { apiVersion } = getState().runtime;
  const { coachmarks, user } = getState();
  const { applicationId } = user;
  const { locale } = getState().intl;
  dispatch(coachmarksApiRequest());

  const coachmarkData = {
    ...coachmarks,
    [`${context}_coachmarks_complete`]: true,
  };

  const serverData = {
    student_application_id: applicationId,
    ...coachmarkData,
  };

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/settings/update-coachmarks/`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/json; charset=UTF-8',
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'PUT',
    body: JSON.stringify(serverData),
  })
    .then(fetchErrorHandler)
    .then(resp => resp.json())
    .then(() => {
      dispatch(
        setCoachmarks({
          data: coachmarkData,
        }),
      );
      dispatch(coachmarksApiSuccess());
    })
    .catch(error => {
      console.error('error', error);
      dispatch(coachmarksApiFailure({ error }));
    });
};

export default dismissCoachmark;
